import svgData from "./svgData";
import { PathElement } from "../../svgHelpers";
import type { SVGProps, SVGElementProps } from "../../types";

const CaretRight: SVGProps = (props: SVGElementProps) => <PathElement {...props} path={svgData.path.d} />;

export default CaretRight;
